const Reducer = (state, action) => {
  switch (action.type) {
    case 'SET_PRODUCT_DATA':
      return {
        ...state,
        productData: action.payload,
      };
    case 'SET_COLOR_DATA':
      return {
        ...state,
        colorData: action.payload,
      };
    case 'SET_PRODUCT_MODS':
      return {
        ...state,
        productMods: action.payload,
      };
    case 'SET_SELECTED_COLOR':
      return {
        ...state,
        selectedColor: action.payload,
      };
    case 'SET_SELECTED_MARKING':
      return {
        ...state,
        selectedMarking: action.payload,
      };
    case 'SET_SELECTED_MODS':
      return {
        ...state,
        selectedMods: action.payload,
      };
    case 'SET_SELECTED_VIEW':
      return {
        ...state,
        selectedView: action.payload,
      };
    case 'SET_USER_DATA':
      return {
        ...state,
        userData: action.payload,
      };
    default:
      return state;
  }
};

export default Reducer;
